<template>
  <div
    style="background-size: cover; background-position: 50% 50%"
    :style="{
      height: clientHeight + 'px',
      backgroundImage: `url(${HomeConfigs.HomeBackgroundImageFormat})`,
    }"
  >

    <div
      class="home_area"
      :style="{ height: clientHeight + 'px' }"
      style="overflow: auto"
    >
      <div class="content">
        <!-- <LanguageSelect /> -->
        <div v-html="shuoming.Value" class="shuoming"></div>
      </div>
    </div>
    <div class="start_area" v-if="IsShowCart" style="animation: scaleAnimation 3s infinite; ">
      <div
        class="start_preview"
        @click="GoPreview"
        v-if="HomeConfigs.IsTuiGuang"
      >
        <van-icon name="eye-o" size="50" class="start_btn" />
      </div>
      <div
        class="start_border"
        @click="GoOrder"
        :style="{
          'background-color':
            'rgba(' +
            StartBorderColors.R +
            ', ' +
            StartBorderColors.G +
            ', ' +
            StartBorderColors.B +
            ', ' +
            StartBorderColors.A / 255 +
            ')',
        }"
      >
        <!-- <img :src="image" style="width: 80px; height: 80px; margin-top: 15px" /> -->

        <van-icon
          color="red"
          class="start_btn"
          style="width: 70px; height: 70px"
          v-if="HomeConfigs.openTable"
        >
          <svg
            t="1712912573689"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4403"
          >
            <path
              d="M190.08 946.57024c-0.00512 0-0.00512 0 0 0-19.77344 0-40.07424-6.02112-54.2976-16.10752-12.65152-8.96-20.608-24.70912-22.42048-44.34944-2.18624-23.72608 4.77184-47.66208 17.71008-60.99456 16.21504-16.69632 244.92032-228.82816 297.20576-277.30432l-24.03328-25.8304c-9.6256 1.024-27.63264 2.62656-46.19776 2.62656-16.2816 0-29.71136-1.25952-39.92064-3.73248-6.79936-1.64352-18.49856-7.05536-48.92672-34.53952-19.328-17.45408-42.73664-40.81664-65.92-65.78176-20.44416-22.02624-87.89504-96.41984-97.23904-129.10592-12.35968-43.22816-6.0928-93.37344-4.9664-101.4272 0.31744-21.49376 10.07104-60.39552 45.312-60.39552 22.38976 0 50.00192 16.90624 84.42368 51.6864 19.45088 19.65056 238.18752 236.99456 287.85152 286.34112l29.88032-30.81728c-13.03552-11.78112-32.27648-32.0256-36.43904-52.0448-5.68832-27.33568 0.52736-39.94624 12.89728-65.0752 1.1776-2.39104 2.432-4.93056 3.74784-7.64928 21.17632-43.4688 177.40288-183.54176 204.27776-204.15488 7.97696-6.10816 16.4096-9.21088 25.06752-9.21088 14.57664 0 28.18048 9.15968 35.50208 23.89504 6.08256 12.24704 5.86752 25.1136-0.5376 33.57696-9.50272 12.53376-147.97824 154.86464-166.03648 173.4144-4.52096 5.72416-14.17216 21.76512-8.36096 27.57632 0.5376 0.5376 1.11616 0.98816 2.72384 0.98816 7.36256 0 19.00544-8.35072 23.40352-12.33408 8.55552-8.46336 150.4768-148.85888 163.1488-160.91648 7.22944-6.88128 15.80032-10.51648 24.76544-10.51648 16.96256 0 30.33088 12.70272 36.06528 25.29792 5.66272 12.4672 4.52608 25.10848-3.06688 33.81248-12.00128 13.76256-155.05408 170.58816-161.14176 177.2544l-0.45568 0.47616c-1.92512 1.9968-10.38848 11.58144-3.8656 19.8912 0.91136 1.17248 1.5616 1.48992 3.01056 1.48992 6.16448 0 16.17408-6.59456 20.4288-10.2912 7.2448-7.14752 150.64576-148.5312 166.72768-164.51072 5.7856-5.74464 13.50144-8.7808 22.30272-8.7808 18.06336 0 38.90688 13.12256 46.47424 29.25056 4.736 10.09152 3.712 20.38272-2.816 28.22656-0.67072 0.80384-1.6896 2.05312-3.03616 3.6864-40.04864 48.65024-77.184 91.008-110.38208 125.89568-89.18528 93.76256-122.29632 104.59648-139.43296 104.59648-2.18112 0-4.30592-0.19456-6.31808-0.5888-28.47232-5.54496-53.5808-22.26688-67.35872-32.99328l-33.05984 38.50752c49.37216 48.128 278.27712 271.32416 288.67584 281.46688 9.55904 9.3184 18.60096 30.89408 17.37728 54.08768-1.04448 19.70688-9.35424 36.22912-24.02304 47.77472-13.44 10.57792-31.20128 16.4096-50.01728 16.4096-20.70016 0-39.35744-7.10656-48.68608-18.54464-9.23648-11.31008-169.344-190.72-261.17632-293.46304l-277.9136 294.2208c-11.57632 12.26752-29.6704 19.01568-50.944 19.01568l0.01024-0.00512zM414.90944 492.6976l52.63872 56.56576-10.20416 9.45152c-2.88256 2.67264-288.94208 267.8016-306.36032 285.7472-7.07072 7.28576-11.3664 24.09472-9.984 39.11168 1.03936 11.26912 4.98688 20.10624 10.82368 24.2432 9.56928 6.77376 24.2176 10.98752 38.2464 10.98752h0.00512c13.35808 0 24.57088-3.75808 30.76096-10.31168l298.66496-316.1856 10.06592 11.264c10.5984 11.84768 259.69152 290.52928 272.05632 305.67424 3.3024 4.03456 13.94176 8.33536 27.17696 8.33536 12.61056 0 24.2688-3.71712 32.83968-10.46528 8.32-6.54336 12.85632-15.77472 13.47584-27.42784 0.79872-15.16032-5.36064-29.1584-9.03168-32.7424l-298.0096-290.56512-9.3184-9.088 68.50048-79.80544 10.58816 10.08128c0.29184 0.27136 30.55104 28.62592 64.67584 35.2768 0.18944 0.03584 0.512 0.08192 1.00864 0.08192 21.66272 0 94.46912-57.71776 228.37248-220.37504l2.15552-2.61632c-2.01728-4.5824-12.75904-13.13792-21.33504-13.13792-1.34144 0-2.26304 0.24064-2.74432 0.7168-16.45568 16.34816-165.57568 163.36384-167.07072 164.84864l-0.512 0.47616c-2.01728 1.79712-20.21888 17.536-39.1424 17.54112-10.05056 0-18.65216-4.18816-24.86784-12.12416-17.50016-22.3232-3.95776-46.49984 5.87264-56.43264 6.3232-6.9376 147.1232-161.28512 160.2816-176.28672 0.11776-0.9984-0.37888-4.16256-3.09248-7.7568-2.58048-3.40992-6.02112-5.61664-8.74496-5.61664-1.73568 0-3.63008 0.96768-5.62688 2.87232-12.60032 11.9808-161.4592 159.25248-162.95936 160.73728l-0.37376 0.36352c-2.21184 2.0224-22.15936 19.79904-42.35776 19.79904-8.6528 0-16.37376-3.14368-22.34368-9.10848-20.34176-20.3264-5.24288-50.59584 6.87616-65.27488l0.75776-0.8448c58.54208-60.12928 152.91392-157.72672 163.6096-170.48576-0.04096-1.63328-1.07008-5.51424-4.07552-9.10336-1.44384-1.72544-4.41856-4.62336-8.1152-4.62336-2.41152 0-5.15584 1.17248-8.1664 3.47648-12.72832 9.76384-57.68704 49.34656-101.9904 91.648-74.64448 71.28064-90.76224 95.51872-94.22336 102.6304-1.34144 2.75968-2.61632 5.33504-3.80416 7.76192-11.60704 23.57248-14.36672 29.17376-10.62912 47.1552 3.00032 14.36672 24.91904 35.60448 38.03136 45.61408l12.42112 9.48224-70.70208 72.91904-9.96352-9.90208c-2.75968-2.7392-276.06528-274.2528-297.98912-296.41216-37.42208-37.80608-56.59648-43.45344-64.69632-43.45344-2.82624 0-9.44128 0-14.16192 13.7984-3.29216 9.6256-3.39968 19.84-3.39968 19.9424l-0.00512 1.01376-0.1536 1.04448c-0.07168 0.49152-7.43424 50.41664 4.06528 90.63936 4.82816 16.88064 41.96352 65.08032 90.30144 117.20704 55.08096 59.40224 93.21984 90.53184 101.64736 92.87168 8.04352 1.9456 19.2768 2.93888 33.36192 2.93888 24.95488 0 49.53088-3.18464 49.77664-3.21536l7.09632-0.95744z"
              p-id="4404"
              fill="#ffffff"
            ></path>
          </svg>
        </van-icon>

        <van-icon
          color="red"
          class="start_btn"
          style="width: 70px; height: 70px"
          v-if="!HomeConfigs.openTable"
        >
          <svg
            v-if="!HomeConfigs.IsOpenPreview"
            t="1712912573689"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4403"
          >
            <path
              d="M190.08 946.57024c-0.00512 0-0.00512 0 0 0-19.77344 0-40.07424-6.02112-54.2976-16.10752-12.65152-8.96-20.608-24.70912-22.42048-44.34944-2.18624-23.72608 4.77184-47.66208 17.71008-60.99456 16.21504-16.69632 244.92032-228.82816 297.20576-277.30432l-24.03328-25.8304c-9.6256 1.024-27.63264 2.62656-46.19776 2.62656-16.2816 0-29.71136-1.25952-39.92064-3.73248-6.79936-1.64352-18.49856-7.05536-48.92672-34.53952-19.328-17.45408-42.73664-40.81664-65.92-65.78176-20.44416-22.02624-87.89504-96.41984-97.23904-129.10592-12.35968-43.22816-6.0928-93.37344-4.9664-101.4272 0.31744-21.49376 10.07104-60.39552 45.312-60.39552 22.38976 0 50.00192 16.90624 84.42368 51.6864 19.45088 19.65056 238.18752 236.99456 287.85152 286.34112l29.88032-30.81728c-13.03552-11.78112-32.27648-32.0256-36.43904-52.0448-5.68832-27.33568 0.52736-39.94624 12.89728-65.0752 1.1776-2.39104 2.432-4.93056 3.74784-7.64928 21.17632-43.4688 177.40288-183.54176 204.27776-204.15488 7.97696-6.10816 16.4096-9.21088 25.06752-9.21088 14.57664 0 28.18048 9.15968 35.50208 23.89504 6.08256 12.24704 5.86752 25.1136-0.5376 33.57696-9.50272 12.53376-147.97824 154.86464-166.03648 173.4144-4.52096 5.72416-14.17216 21.76512-8.36096 27.57632 0.5376 0.5376 1.11616 0.98816 2.72384 0.98816 7.36256 0 19.00544-8.35072 23.40352-12.33408 8.55552-8.46336 150.4768-148.85888 163.1488-160.91648 7.22944-6.88128 15.80032-10.51648 24.76544-10.51648 16.96256 0 30.33088 12.70272 36.06528 25.29792 5.66272 12.4672 4.52608 25.10848-3.06688 33.81248-12.00128 13.76256-155.05408 170.58816-161.14176 177.2544l-0.45568 0.47616c-1.92512 1.9968-10.38848 11.58144-3.8656 19.8912 0.91136 1.17248 1.5616 1.48992 3.01056 1.48992 6.16448 0 16.17408-6.59456 20.4288-10.2912 7.2448-7.14752 150.64576-148.5312 166.72768-164.51072 5.7856-5.74464 13.50144-8.7808 22.30272-8.7808 18.06336 0 38.90688 13.12256 46.47424 29.25056 4.736 10.09152 3.712 20.38272-2.816 28.22656-0.67072 0.80384-1.6896 2.05312-3.03616 3.6864-40.04864 48.65024-77.184 91.008-110.38208 125.89568-89.18528 93.76256-122.29632 104.59648-139.43296 104.59648-2.18112 0-4.30592-0.19456-6.31808-0.5888-28.47232-5.54496-53.5808-22.26688-67.35872-32.99328l-33.05984 38.50752c49.37216 48.128 278.27712 271.32416 288.67584 281.46688 9.55904 9.3184 18.60096 30.89408 17.37728 54.08768-1.04448 19.70688-9.35424 36.22912-24.02304 47.77472-13.44 10.57792-31.20128 16.4096-50.01728 16.4096-20.70016 0-39.35744-7.10656-48.68608-18.54464-9.23648-11.31008-169.344-190.72-261.17632-293.46304l-277.9136 294.2208c-11.57632 12.26752-29.6704 19.01568-50.944 19.01568l0.01024-0.00512zM414.90944 492.6976l52.63872 56.56576-10.20416 9.45152c-2.88256 2.67264-288.94208 267.8016-306.36032 285.7472-7.07072 7.28576-11.3664 24.09472-9.984 39.11168 1.03936 11.26912 4.98688 20.10624 10.82368 24.2432 9.56928 6.77376 24.2176 10.98752 38.2464 10.98752h0.00512c13.35808 0 24.57088-3.75808 30.76096-10.31168l298.66496-316.1856 10.06592 11.264c10.5984 11.84768 259.69152 290.52928 272.05632 305.67424 3.3024 4.03456 13.94176 8.33536 27.17696 8.33536 12.61056 0 24.2688-3.71712 32.83968-10.46528 8.32-6.54336 12.85632-15.77472 13.47584-27.42784 0.79872-15.16032-5.36064-29.1584-9.03168-32.7424l-298.0096-290.56512-9.3184-9.088 68.50048-79.80544 10.58816 10.08128c0.29184 0.27136 30.55104 28.62592 64.67584 35.2768 0.18944 0.03584 0.512 0.08192 1.00864 0.08192 21.66272 0 94.46912-57.71776 228.37248-220.37504l2.15552-2.61632c-2.01728-4.5824-12.75904-13.13792-21.33504-13.13792-1.34144 0-2.26304 0.24064-2.74432 0.7168-16.45568 16.34816-165.57568 163.36384-167.07072 164.84864l-0.512 0.47616c-2.01728 1.79712-20.21888 17.536-39.1424 17.54112-10.05056 0-18.65216-4.18816-24.86784-12.12416-17.50016-22.3232-3.95776-46.49984 5.87264-56.43264 6.3232-6.9376 147.1232-161.28512 160.2816-176.28672 0.11776-0.9984-0.37888-4.16256-3.09248-7.7568-2.58048-3.40992-6.02112-5.61664-8.74496-5.61664-1.73568 0-3.63008 0.96768-5.62688 2.87232-12.60032 11.9808-161.4592 159.25248-162.95936 160.73728l-0.37376 0.36352c-2.21184 2.0224-22.15936 19.79904-42.35776 19.79904-8.6528 0-16.37376-3.14368-22.34368-9.10848-20.34176-20.3264-5.24288-50.59584 6.87616-65.27488l0.75776-0.8448c58.54208-60.12928 152.91392-157.72672 163.6096-170.48576-0.04096-1.63328-1.07008-5.51424-4.07552-9.10336-1.44384-1.72544-4.41856-4.62336-8.1152-4.62336-2.41152 0-5.15584 1.17248-8.1664 3.47648-12.72832 9.76384-57.68704 49.34656-101.9904 91.648-74.64448 71.28064-90.76224 95.51872-94.22336 102.6304-1.34144 2.75968-2.61632 5.33504-3.80416 7.76192-11.60704 23.57248-14.36672 29.17376-10.62912 47.1552 3.00032 14.36672 24.91904 35.60448 38.03136 45.61408l12.42112 9.48224-70.70208 72.91904-9.96352-9.90208c-2.75968-2.7392-276.06528-274.2528-297.98912-296.41216-37.42208-37.80608-56.59648-43.45344-64.69632-43.45344-2.82624 0-9.44128 0-14.16192 13.7984-3.29216 9.6256-3.39968 19.84-3.39968 19.9424l-0.00512 1.01376-0.1536 1.04448c-0.07168 0.49152-7.43424 50.41664 4.06528 90.63936 4.82816 16.88064 41.96352 65.08032 90.30144 117.20704 55.08096 59.40224 93.21984 90.53184 101.64736 92.87168 8.04352 1.9456 19.2768 2.93888 33.36192 2.93888 24.95488 0 49.53088-3.18464 49.77664-3.21536l7.09632-0.95744z"
              p-id="4404"
              fill="#ffffff"
            ></path>
          </svg>

          <svg
            v-else
            t="1718172163157"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="20490"
          >
            <path
              d="M869.1 488.1c18.5 10.7 18.5 37.5 0 48.2L525.2 734.8 181.4 933.2c-18.5 10.7-41.7-2.7-41.7-24.1V115.3c0-21.4 23.2-34.8 41.7-24.1l343.8 198.4 343.9 198.5z"
              fill="#CBCBCB"
              p-id="20491"
            ></path>
            <path
              d="M960.2 856.5c0 8.79999999-2.3 17.5-6.9 25.5-9.2 16-25.79999999 25.5-44.2 25.5L115.3 907.5c-18.5 0-35-9.5-44.2-25.50000001s-9.2-35.1 0-51.09999998L468 143.3c9.2-16 25.79999999-25.5 44.2-25.5 18.5 0 35 9.5 44.2 25.5L953.3 831c4.6 7.9 6.9 16.70000001 6.9 25.5z m-849.5 0c0 0.79999999 0.2 1.5 0.7 2.3 0.9 1.5 2.2 2.3 4 2.3l793.7 0c1.80000001 0 3.1-0.8 4-2.3 0.9-1.5 0.9-3.1 0-4.6l-396.9-687.6c-0.9-1.5-2.2-2.3-4-2.29999999-1.80000001 0-3.1 0.8-4 2.29999999L111.4 854.2c-0.5 0.7-0.7 1.5-0.7 2.3z"
              fill="#7D7D7D"
              p-id="20492"
            ></path>
          </svg>
        </van-icon>
      </div>
    </div>
  </div>


  <!-- 语言 -->
  <div
    style="
      width: 100%;
      height: 70px;
      display: flex;
      justify-content: center;
      gap: 20px;
      position: fixed; 
      justify-items: center;
    "
    :style="{top:LangTop+'px'}"
  >
    <div
      v-for="item in LanguageList"
      :key="item"
      style="width: 50px; text-align: center"
      @click="LanguageOpts(item.Id)"
    >
      <div style="width: 50px">
        <van-image style="width: 30px" :src="item.CompleteImage"></van-image>
      </div>
      <div
        style="width: 50px; font-size: 8pt; color: #fff"
        :style="{ color: item.Id == LanguageOpt ? 'red' : '#fff' }"
      >
        {{ item.Name }}
      </div>
    </div>
  </div>
  <!-- <div
      v-if="this.RecommendCollectionModel.IsRecommendTime"
      style="
        position: fixed;
        width: 100%;
        bottom: 220px;
        text-align: center;
        z-index: 99999; animation: scaleAnimation 4s infinite; 
      " 
    >
      <van-icon
        name="fire"
        color="red"
        size="50"
        @click="IsRecommendTimeShow = true"
      />
      <div style="color: #fff" @click="IsRecommendTimeShow = true">
        {{ tools.GetLanguageValue("public.app.每日推荐") }}
      </div>
    </div> -->

  <!-- 首页LOGO -->
  <div style="width: 100%; text-align: center; position: fixed; " :style="{top:LogoTop+'PX'}" v-if="UseLogoImage">
    <img :src="HomeConfigs.homeLogo.ValueFormat" style="width: 70%" />
  </div>


  <!-- 推荐每日套餐 -->
  <van-popup
    v-model:show="IsRecommendTimeShow"
    position="bottom"
    :style="{ height: '100%' }"
    style="z-index: 3333333333333"
  >
    <div
      style="
        overflow: auto;
        height: calc(100%);
        position: relative;
        text-align: center;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          height: 45px;
          width: 100%;
          border-bottom: 1px #eee solid; 
        "
      >
        <div style="width: 120px">
          <van-icon name="fire" color="red" size="30" />
        </div>
        <p>
          {{ tools.GetLanguageValue("public.app.每日推荐") }}
        </p>
      </div>
      <div
        style="
          min-height: 60px;
          position: relative;
          border: 1px solid #eee;
          margin: 0 auto;
          margin-top: 10px;
          background-color: #eee;
          padding: 5px;
          width: calc(100% - 20px);
          border-radius: 8px;
        "
        v-for="(item, index) in RecommendCollectionModel.Collections"
        :key="index"
      > 
        <p>
          {{ item.Name }}
        </p>
        <div
          style="
            position: absolute;
            left: 1px;
            top: 1px;
            color: red;
            font-size: 18pt;
          "
        >
          {{ item.Price }}
        </div>
        <button
          style="
            width: 120px;
            border: 0px;
            height: 35px;
            background-color: chocolate;
            color: #fff;
          "
          @click="AddRecommendCollection(item)"
        >
          {{ tools.GetLanguageValue("public.app.添加") }}
        </button>
      </div>
      <div
        style="
          position: absolute;
          bottom: 10px;
          text-align: center;
          width: calc(100% - 30px);
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 0 auto;

          left: 15px;
        "
      >
        <van-button
          icon="cross"
          type="default"
          @click="IsRecommendTimeShow = false"
          style="height: 35px; width: 120px"
        >
          {{ tools.GetLanguageValue("public.app.关闭") }}
        </van-button>

        <van-button
          icon="shopping-cart-o"
          type="default"
          @click="GoOrder"
          style="height: 35px; width: 120px"
        >
          {{ tools.GetLanguageValue("public.app.点餐") }}
        </van-button>
      </div>
    </div>
  </van-popup>

  <!-- 温馨提示 -->
  <van-popup
    v-model:show="OpenPhonewarmreminderWindow"
    position="bottom"
    :style="{ height: '100%' }"
    style="z-index: 6333333333333"
  >
    <div style="overflow: auto; height: calc(100%)">
      <div v-html="PhoneWarmReminderHtml" style="padding: 5px"></div>
    </div>

    <div
      style="width: 100%; text-align: center; position: absolute; bottom: 10px"
    >
      <van-button
        type="warning"
        style="margin: 0 auto; margin: 5px"
        @click="ConsentPhonewarmreminde"
      >
        {{ tools.GetLanguageValue("public.app.我同意") }}
      </van-button>
    </div>
  </van-popup>

</template>
<script>
import axios from "../../commons/AxiosMethod.js";
import productBbroadwise from "../../components/tabbars/StoreProductBroadwise.vue";
import tabbar from "../../components/tabbars/storeTabbar.vue";
import LanguageSelect from "../../components/LanguageSelect.vue";
import tools from "../../commons/tools.js";
import {
  Collapse,
  CollapseItem,
  Tab,
  Tabs,
  showToast,
  NumberKeyboard,
} from "vant";

export default {
  data() {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      shuoming: "",
      HomeConfigs: {
        homeLogo: {},
      }, // 配置
      IsShowCart: true,
      tools: tools,
      PreviewWindow: false, // 预览弹窗
      StartBorderColors: { A: 255, R: 255, G: 255, B: 255 },
      OpenPhonewarmreminderWindow: false,
      PhoneWarmReminderHtml: "",
      LanguageList: [],
      LanguageOpt: {},
      RecommendCollectionModel: {
        IsRecommendTime: false,
      },
      IsRecommendTimeShow: false,
      LangTop:90, //语言位置
      LogoTop:190,//LOGO位置

      
    };
  },
  name: "App",
  mounted() {
    localStorage.setItem("Cache-TableId", this.$route.query.tableId);

    this.TableId = localStorage.getItem("Cache-TableId");

    this.GetHomeType();
    this.GetLanguageList();
    this.GetRecommendCollection();

    window.onresize = () => {
      // 屏幕尺寸变化就重新赋值
      return (() => {
        this.clientHeight = document.documentElement.clientHeight;
      })();
    };
  },
  components: {
    productBbroadwise,
    tabbar,
    LanguageSelect,
  },
  methods: {
    ConsentPhonewarmreminde() {
      this.OpenPhonewarmreminderWindow = false;
    },
    //添加每日套餐
    AddRecommendCollection(item) {
      var tableId = localStorage.getItem("Cache-TableId");
      this.$router.push({
        path: "storeRecommendCollection",
        query: {
          tableId: tableId,
          collectionId: item.Id,
        },
      });
    },
    //获取推荐套餐
    GetRecommendCollection() {
      axios.apiMethod(
        "/Store/StoreOrder/GetRecommendCollection",
        "get",
        {},
        (result) => {
          this.RecommendCollectionModel = result.Data;

          this.IsRecommendTimeShow =
            this.RecommendCollectionModel.IsRecommendTime;
        },
        (e) => {}
      );
    },
    // 去预览
    GoPreview() {
      this.Skip("storePreview");
    },

    LanguageOpts(item) {
      this.LanguageOpt = item;
      localStorage.setItem("LanguageOpt", this.LanguageOpt);

      this.GetLanguageById(this.LanguageOpt, () => {
        window.location.href = window.location.href;
      });
    },
    // 获取语言列表
    GetLanguageList() {
      axios.apiMethod(
        "/api/Language/GetLanguageList",
        "get",
        {},
        (result) => {
          this.LanguageList = result.Data;
          localStorage.setItem("LanguageList", result.Data);
          this.LanguageOpt = localStorage.getItem("LanguageOpt");

          if (
            this.LanguageOpt == null ||
            this.LanguageOpt == "" ||
            this.LanguageOpt == undefined ||
            this.LanguageOpt == "undefined"
          ) {
            console.log(this.LanguageOpt);
            for (var i = 0; this.LanguageList.length > i; i++) {
              if (this.LanguageList[i].Default) {
                this.LanguageOpt = this.LanguageList[i].Id;
                this.LanguageOptOld = this.LanguageList[i].Id;
                this.GetLanguageById(this.LanguageOptOld);
              }
            }
          } else {
            this.GetLanguageById(this.LanguageOpt, () => {});
          }
        },
        (e) => {}
      );
    },
    GetLanguageById(id, funcs) {
      axios.apiMethod(
        "/api/Language/GetLanguageById",
        "get",
        { languageId: id },
        (result) => {
          localStorage.setItem(
            "LanguageRepertory",
            JSON.stringify(result.Data)
          );
          try {
            funcs();
          } catch (e) {}
          // window.location.href = window.location.href;
        },
        (e) => {}
      );
    },
    // 获取定位
    GetDistance() {
      var _this = this;
      function getLocation() {
        if (navigator.geolocation) {
          var getOptions = {
            // 是否使用高精度设备，如GPS。默认是true
            enableHighAccuracy: true,
            // 超时时间，单位毫秒，默认为0
            timeout: 3000,
            // 使用设置时间内的缓存数据，单位毫秒
            // 默认为0，即始终请求新数据
            // 如设为Infinity，则始终使用缓存数据
            maximumAge: 0,
          };

          navigator.geolocation.getCurrentPosition(
            getSuccess,
            (err) => {
              var err = err.code + ":" + err.message;

              _this.Skip("storenotlocation");
            },
            getOptions
          );
        } else {
          alert("无法获取定位！");
          _this.Skip("storenotlocation");
        }
      }
      function getSuccess(position) {
        // 如果table是guid，那么开始验证
        axios.apiMethod(
          "/GoogeMap/GoogeMap/GetDistance",
          "get",
          {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          },
          (result) => {
            if (!result.Data.distance) {
              _this.Skip("storeoutofrange");
            }
          }
        );
      }

      getLocation();
    },

    // 查询订单
    GoOrder() {
      if (!this.HomeConfigs.openTable) {
        //如果没有开台去预览页面
        if (this.HomeConfigs.IsOpenPreview) {
          this.Skip("storePreviewAll");
        } else {
          showToast(tools.GetLanguageValue("public.app.未开台"));
        }

        return;
      }

      var datas = JSON.parse(this.HomeConfigs.Value);
      this.HomeTypes = datas.HomeTypes;

      if (this.HomeTypes.length == 0) {
        this.HomeTypes.push("Default");
      }

      if (this.HomeTypes.indexOf("FixedTaoCan") > -1) {
        localStorage.setItem("FixedTaoCan", datas.CollectionOpt);
        this.Skip("storeCollectionFixed");

        return;
      }

      if (
        this.HomeTypes.indexOf("Product") > -1 ||
        this.HomeTypes.indexOf("Default") > -1
      ) {
        if (localStorage.getItem("IsStoreCategorySidebar") == "yes") {
          this.Skip("storeCategorySidebar");
        } else {
          this.Skip("storeorder");
        }
      } else if (this.HomeTypes.indexOf("TaoCan") > -1) {
        this.Skip("storeCollection");
      } else if (this.HomeTypes.indexOf("TaoCanQianTai") > -1) {
        this.Skip("storeCollectionQianTai");
      }
    },
    GetHomeType() {
      axios.apiMethod(
        "/Store/StoreOrder/GetHomeType",
        "get",
        { tableId: this.TableId },
        (result) => {
          this.HomeConfigs = result.Data;

          localStorage.setItem(
            "AppSystemSettings",
            JSON.stringify(this.HomeConfigs)
          );

          this.StartBorderColors = result.Data.StartBorderColors;
          if(result.Data.LangTop >0){
            this.LangTop = result.Data.LangTop;
          }
          if(result.Data.LogoTop >0){  
            this.LogoTop = result.Data.LogoTop;
          }

          this.UseLogoImage = result.Data.UseLogoImage;
          this.shuoming = this.HomeConfigs.shuoming;

          localStorage.setItem(
            "ProductImageHeigth",
            this.HomeConfigs.ProductImageHeigth
          );

          localStorage.setItem(
            "IsTuiGuang",
            this.HomeConfigs.IsTuiGuang ? "yes" : "no"
          );

          localStorage.setItem(
            "addcartDetailed",
            this.HomeConfigs.addcartDetailed ? "yes" : "no"
          );
          localStorage.setItem(
            "IsShowOverProduct",
            this.HomeConfigs.IsShowOverProduct ? "yes" : "no"
          );
          localStorage.setItem(
            "UseSecurityCode",
            this.HomeConfigs.useSecurityCode ? "yes" : "no"
          );
          localStorage.setItem(
            "IsStoreCategorySidebar",
            this.HomeConfigs.IsStoreCategorySidebar ? "yes" : "no"
          );
          // 是否显示价格
          localStorage.setItem(
            "IsOrderShowCost",
            this.HomeConfigs.IsOrderShowCost ? "yes" : "no"
          );

          if (!result.Data.openTable) {
            showToast(tools.GetLanguageValue("public.app.未开台"));
            return;
          }

          // 是否启用店内定位
          if (result.Data.locationUsing) {
            this.GetDistance();
            return;
          }

          // 是否启用弹出温馨提示
          if (result.Data.OpenPhonewarmreminder) {
            this.OpenPhonewarmreminderWindow = true;
            this.PhoneWarmReminderHtml = result.Data.PhoneWarmReminderHtml;

            return;
          }

          this.skipHome = this.HomeConfigs.skipHome;
          if (this.skipHome) {
            // 跳过首页
            this.GoOrder();
          }
        }
      );
    },
    Skip(item) {
      var tableId = localStorage.getItem("Cache-TableId");
      this.$router.push({
        path: item,
        query: {
          tableId: tableId,
        },
      });
    },
  },
};
</script>
<style>
.shuoming p {
  padding: 0px !important;
  margin: 0px !important;
}
</style>
<style lang="scss" scoped>
.home_area {
  width: 100%;

  .content {
    width: 100%;
    font-size: 8pt !important;
    margin: 0px !important;
    position: relative;
  }
}

.start_area {
  z-index: 1000000000;
  position: fixed;
  width: 100%;
  bottom: 70px;
  display: flex;
  align-items: center;
  // animation: mybottom 4s;
  // -webkit-animation: mybottom 4s;
  // animation-fill-mode: forwards;
  // -webkit-animation-fill-mode: forwards;
  /* Safari 和 Chrome */

  .start_preview {
    margin: 0 auto;
    height: 130px;
    width: 130px;
    background-color: #434343;
    // opacity: 0.2 ;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 69px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    .start_btn {
      font-size: 35pt;
    }
  }

  .start_border {
    // animation: myfirst 4s;
    // -webkit-animation: myfirst 4s;
    // animation-fill-mode: forwards;
    // -webkit-animation-fill-mode: forwards;
    /* Safari 和 Chrome */

    /* Safari and Chrome */
    margin: 0 auto;
    height: 130px;
    width: 130px;
    background-color: #434343;
    // opacity: 0.2 ;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 69px;
    color: #fff;
    display: flex;
    justify-content: center;

    .start_btn {
      font-size: 35pt;
      margin-top: 25px;
    }
  }
}

@keyframes mybottom {
  0% {
    bottom: 10px;
  }

  100% {
    bottom: 400px;
  }
}

@keyframes myfirst {
  0% {
    background-color: #ffffff;
  }

  10% {
    color: #fff;
  }

  50% {
    background-color: #fb0c0c;
    color: #fff;
  }

  100% {
    background-color: #fb0c0c;
    color: #fff;
    bottom: 400px;
  }
}

.input_area {
  position: absolute;
  top: 200px;
  width: 100%;
}


</style>
<style  >
@keyframes scaleAnimation {
  0% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1.1);
  }
}
</style>